/** Gap extra sobre a linha de base do navegador (sem DevTools) para considerar painel aberto. */
const DEVTOOLS_EXTRA_GAP_THRESHOLD = 140

const CALIBRATION_SAMPLES = 6

type GapSnapshot = { widthGap: number; heightGap: number }

let baseline: GapSnapshot = { widthGap: 0, heightGap: 0 }
let calibrationCount = 0

function readWindowGaps(): GapSnapshot {
  if (typeof window === 'undefined') {
    return { widthGap: 0, heightGap: 0 }
  }
  return {
    widthGap: Math.max(0, window.outerWidth - window.innerWidth),
    heightGap: Math.max(0, window.outerHeight - window.innerHeight),
  }
}

function updateBaseline(gaps: GapSnapshot) {
  baseline = {
    widthGap: Math.max(baseline.widthGap, gaps.widthGap),
    heightGap: Math.max(baseline.heightGap, gaps.heightGap),
  }
}

/** Reinicia calibração (ex.: após resize prolongado). */
export function resetDevtoolsDetectionBaseline() {
  baseline = { widthGap: 0, heightGap: 0 }
  calibrationCount = 0
}

/**
 * DevTools acoplado aumenta outer−inner além da UI normal do browser (abas, barra de endereço).
 * Calibramos a UI normal no boot para não confundir com painel do inspetor.
 */
export function isDevtoolsOpenByDimensions(): boolean {
  const gaps = readWindowGaps()

  if (calibrationCount < CALIBRATION_SAMPLES) {
    updateBaseline(gaps)
    calibrationCount += 1
    return false
  }

  const widthDelta = gaps.widthGap - baseline.widthGap
  const heightDelta = gaps.heightGap - baseline.heightGap

  if (widthDelta > DEVTOOLS_EXTRA_GAP_THRESHOLD || heightDelta > DEVTOOLS_EXTRA_GAP_THRESHOLD) {
    return true
  }

  // UI do browser pode crescer (zoom, barra de favoritos) — atualiza baseline sem alarmar
  if (widthDelta <= 0 && heightDelta <= 0) {
    updateBaseline(gaps)
  }

  return false
}

/** Apenas atalhos e dimensão calibrada — evita debugger/console que geram falso positivo. */
export function isDevtoolsOpen(): boolean {
  try {
    return isDevtoolsOpenByDimensions()
  } catch {
    return false
  }
}
